import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import AOS from 'aos'
import 'aos/dist/aos.css'

import App    from './App.vue'
import './assets/main.css'

import HomePage    from './components/HomePage.vue'
import AboutPage   from './components/AboutPage.vue'
import ProductsPage from './components/ProductsPage.vue'
import ServicePage from './components/ServicePage.vue'
import ContactPage from './components/ContactPage.vue'
import FaqsPage    from './components/FaqsPage.vue'

const routes = [
  { path: '/',            component: HomePage,    meta: { title: 'Home — Orel Medical Supplies' } },
  { path: '/about-us',    component: AboutPage,   meta: { title: 'About Us — Orel Medical Supplies' } },
  { path: '/our-products',component: ProductsPage,meta: { title: 'Our Products — Orel Medical Supplies' } },
  { path: '/services',    component: ServicePage, meta: { title: 'Our Services — Orel Medical Supplies' } },
  { path: '/contact-us',  component: ContactPage, meta: { title: 'Contact Us — Orel Medical Supplies' } },
  { path: '/faqs',        component: FaqsPage,    meta: { title: 'FAQs — Orel Medical Supplies' } },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0, behavior: 'smooth' }
  },
})

router.afterEach((to) => {
  document.title = to.meta?.title || 'Orel Medical Supplies'
  // Re-initialize AOS after each route change
  setTimeout(() => AOS.refresh(), 100)
})

const app = createApp(App)
app.use(router)
app.mount('#app')

// Initialize AOS
AOS.init({
  duration: 700,
  easing: 'ease-out-cubic',
  once: true,
  offset: 60,
})
